export default __webpack_public_path__ + "static/media/web.8b3c7bbd.png";